import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function initSinglePartnerBlocks(root = document) {
  const sliders = root.querySelectorAll('.js-partner-gallery-swiper');

  sliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      return;
    }

    const slides = sliderEl.querySelectorAll('.swiper-slide');

    if (slides.length <= 1) {
      const paginationEl = sliderEl.querySelector('.swiper-pagination');
      if (paginationEl) {
        paginationEl.style.display = 'none';
      }
      return;
    }

    new Swiper(sliderEl, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      grabCursor: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

addEventListener('DOMContentLoaded', function () {
  var card = document.querySelector('.partner-mobile-sticky');
  var sentinel = document.querySelector('.single-partner .js-partner-booking-sentinel');
  if (!card || !sentinel || !('IntersectionObserver' in window)) return;

  var SPACER = 20; // = 1.25rem in px (combacia col bottom della card)

  var io = new IntersectionObserver(function (entries) {
    var top = entries[0].boundingClientRect.top;
    card.classList.toggle('is-docked', top <= window.innerHeight - SPACER);
  }, { threshold: 0, rootMargin: '0px 0px -' + SPACER + 'px 0px' });

  io.observe(sentinel);
});

